import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mt-3 me-3 ms-3 alert alert-warning d-flex align-items-center",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-2" }, null, -1)
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "QuickSource UAD 3.6 Beta:", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" We are actively expanding MLS sites and data element support. Please double-check your data before finalizing (for example, dates may default to the first of the month). ")
const _hoisted_6 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("a", {
        href: _ctx.getLink(),
        target: _ctx.getTarget(),
        class: "btn btn-sm btn-outline-dark ms-2"
      }, "Learn More", 8, _hoisted_6)
    ])
  ]))
}